import { useIntl } from "react-intl";
import { Button, Message, TextArea } from "../BP2Components";
import { saveFormV2 } from "../../services/restAPI/endpoints/Forms";
import { useEffect, useState } from "react";
import { TabsData } from "../../util/getDataFromFormTabs";

interface AddSummaryFormProps {
   data: TabsData;
   parentId: string;
   setIsAddSummaryFormOpen: (value: boolean) => void;
   isAddSummaryFormOpen: boolean;
   savedNote: string;
   setSavedNote: (note: string) => void;
}

export const AddSummaryForm = ({
   data,
   parentId,
   setIsAddSummaryFormOpen,
   savedNote,
   setSavedNote,
}: AddSummaryFormProps) => {
   const intl = useIntl();
   const [formData, setFormData] = useState<TabsData>(data);

   useEffect(() => {
      if (savedNote) {
         setFormData((prev) => ({ ...prev, note: savedNote }));
      }
   }, [savedNote]);

   const handleOnChange = (val: string) => {
      setFormData((prev) => ({ ...prev, note: val }));
   };

   const handleSave = async () => {
      Message.loading();
      try {
         await saveFormV2(parentId, null, formData);
         setSavedNote(formData.note);
         Message.destroy();
         Message.success(intl.formatMessage({ id: "callManager.noteChanged" }));
      } catch (e) {
         Message.destroy();
         Message.error(intl.formatMessage({ id: "callManager.noNoteChange" }));
         console.error(e);
      }
      setIsAddSummaryFormOpen(false);
   };

   return (
      <div className="call-manager__add-phone-number">
         <label className="call-manager__add-phone-number-label">
            {intl.formatMessage({ id: "callManager.note" })}
         </label>
         <TextArea
            value={formData.note}
            className="call-manager__text-area"
            onChange={(e) => handleOnChange(e.target.value)}
         />
         <Button buttonType="primary" onClick={handleSave}>
            {intl.formatMessage({ id: "global.save" })}
         </Button>
      </div>
   );
};
